import { render, staticRenderFns } from "./listadoRevisiones.vue?vue&type=template&id=6991b135&scoped=true"
import script from "./listadoRevisiones.vue?vue&type=script&lang=js"
export * from "./listadoRevisiones.vue?vue&type=script&lang=js"
import style0 from "./listadoRevisiones.vue?vue&type=style&index=0&id=6991b135&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6991b135",
  null
  
)

export default component.exports